import PDAHeader from "src/components/common/Header";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1123_R01Info from "./PDA1123_R01Info";
import PDA1123_R01Table from "./PDA1123_R01Table";
import usePDA1123_R01Store from "./usePDA1123_R01Store";

interface Props {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1123_R01Container = ({ menuNm, menuCd, onBack }: Props) => {
  const { loading, reset } = usePDA1123_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={onBack}
        onMenuClick={handleMenuClick}
      />
      <div className="flex-1 overflow-hidden">
        <div className="h-full flex flex-col">
          <PDA1123_R01Info />
          <div className="flex-1 overflow-hidden">
            <PDA1123_R01Table />
          </div>
        </div>
      </div>
      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1123_R01Container;
